module.exports = __webpack_public_path__ + "static/048.thumb-ea4cb10f847f7d7acb7f6be533db5d5f.jpg";